/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum PortGroupMemberTypeE {
    Physical = '0',
    Lif = '1',
    None = '16'
}
